import { gql } from "@apollo/client";

export const GET_COMPANY_PROFILE = gql`
  query getCustomerCompanyProfileDetails {
    getCustomerCompanyProfileDetails {
      company_website
      company_address
      company_domain
      company_services
      customer_company_name
      company_description
      is_significant_data_fiduciary
    }
  }
`;

export const UPDATE_COMPANY_PROFILE = gql`
  mutation updateCustomerCompany($companyDetails: UpdateCustomerCompanyInput) {
    updateCustomerCompany(companyDetails: $companyDetails) {
      customer_company_name
      company_domain
      company_website
      company_services
      company_address
      company_description
      is_significant_data_fiduciary
    }
  }
`;
